<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xBh1JV/tc-custom/9781936932054.jpg?1703426608454" alt="This image is the cover for the book Hunter Maiden, Feminist Folktales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hunter Maiden, Feminist Folktales
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The fourth volume in this beautifully illustrated anthology features traditional tales of heroic women from Russia to South Africa and beyond.</b></p><p>Long before Suzanne Collins created Katniss Everdeen and Octavia Butler wrote <i>Parable of the Sower</i>, there were many traditional folktales full of adventure, intrigue, and intrepid female characters. Feminist Folktales from Around the World collects these forgotten classics and presents them with original artwork by designer and illustrator Suki Boynton.</p><p>Volume four in the series, <i>The Hunter Maiden</i> features an introduction by Renee Watson, the <i>New York Times</i> bestselling author of <i>Piecing Me Together</i>. In these eleven adventures, a diverse cast of female protagonists lend their daring and determination to everything from battling evil wizards in Russia to outsmarting tricky demons in South Africa. In the title story, a young member of the Zuni Native American tribe proves her resourcefulness as she confronts cultural double standards and malicious winter spirits.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ethel Johnston Phelps, Suki Boynton, Renée Watson
      </h2>
      
      <p class="authorDescription body article">Ethel Johnston Phelps (1914-1984) held a master's degree in medieval literature, coedited a Ricardian journal, and published several articles on fifteenth-century subjects. She compiled two anthologies of feminist folktales from around the world, Tatterhood and The Maid of the North.Renée Watson’s books include This Side of Home, nominated for the Best Fiction for Young Adults by the ALA; Harlem’s Little Blackbird: The Story of Florence Mills, nominated for the NAACP Image Award in children’s literature; and A Place Where Hurricanes Happen, featured on NBC Nightly News. She is on the Council of Writers for the National Writing Project and is a team member of We Need Diverse Books. She currently teaches courses on writing for children at University of New Haven and Pine Manor College. In the summer of 2016, she launched I, Too, Arts Collective, a nonprofit committed to nurturing underrepresented voices in the creative arts. She also launched the #LangstonsLegacy Campaign to raise funds to lease the Harlem brownstone where Langston Hughes lived and created during the last twenty years of his life.Suki Boynton is an artist, illustrator, and the senior graphic designer at the Feminist Press. She is a graduate of Connecticut College with a BA in art history and has a degree in graphic design from the Art Institute of Charleston, SC. She currently lives in Newark, NJ.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?208fde58